import { JSX, ChangeEvent, useCallback } from "react";

import IconButton from "@mui/material/IconButton";

import AttachFileIcon from "@mui/icons-material/AttachFile";

export type AttachmentButtonProps = {
	onAttach: (file: File) => void;
};

export default function AttachmentButton(
	props: AttachmentButtonProps
): JSX.Element {
	const uploadFile = useCallback((event: ChangeEvent<HTMLInputElement>) => {
		if (!event.target.files || event.target.files.length === 0) {
			return;
		}

		const file = event.target.files[0];
		props.onAttach(file);
	}, [props.onAttach]);

	return (
		<IconButton component="label" aria-label="attach">
			<AttachFileIcon />
			<input type="file" hidden onChange={uploadFile} />
		</IconButton>
	);
}
